/* script */
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import MeetingRequestThemeForm from 'ui/components/meetings/meeting-requests/theme/MeetingRequestThemeForm.vue';

const __vue_script__ = {
    name: 'MeetingRequestFormSettings',

    components: { MeetingRequestThemeForm },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            event: this.params.event,

            theme: null,
            settingPath: 'meeting_requests_form_theme',
        };
    },

    async created() {
        this.initialize();
    },

    methods: {
        async initialize(skipCache = false) {
            try {
                const eid = this.params.event._id;

                this.theme = await this.$services.settings.getSetting(eid, this.settingPath, skipCache ? 0 : 5000);

            } catch (error) {
                console.error('[MeetingRequestFormSettings] Could not load the theme', error.message);
            }
        },

        async save(data) {
            try {
                console.info('[MeetingRequestFormSettings] Saving settings (%s):', this.settingPath, data);
                const eid = this.params.event._id;

                await this.$services.settings.saveSetting(eid, this.settingPath, data);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('meetings.requests.settings.messages.save_success').toString(),
                    type: 'success',
                    duration: 5000
                });

                this.$emit('saved');
                this.initialize(true);

            } catch (err) {
                console.error('[MeetingRequestFormSettings] Could not save settings', err);

                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('meetings.requests.settings.messages.save_failure').toString(),
                    type: 'error',
                    duration: 5000
                });
            }
        },

        async errorMessage() {
            this.$notify({
                group: 'flashes',
                title: this.$i18n.t('general.error_occurred').toString(),
                text: this.$i18n.t('meetings.requests.settings.messages.save_failure_required_fields').toString(),
                type: 'error',
                duration: 5000
            });
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.theme
    ? _c("meeting-request-theme-form", {
        attrs: { theme: _vm.theme, event: _vm.event },
        on: { valid: _vm.save, invalid: _vm.errorMessage },
      })
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/meetings/meeting-requests/MeetingRequestFormSettings.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__